(function () {
  if (window.cjVerzendGestart) return;
  window.cjVerzendGestart = true;

  var cfg = window.cjVerzend || { drempel: 2500, tipGrens: 900, giftHandle: 'cadeau-item-jadel-verassing' };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var opCart = /\/cart\/?$/.test(location.pathname);
  var KLEIN = 'cj_vb_klein';
  var TIP_MARGE = 1000; // tip mag na korting hoogstens €10 boven het resterende bedrag liggen
  var PIJL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
  var basisFetch = window.fetch.bind(window);

  var laatste = null;
  var tips = null;
  var tipKey = null;
  var tipIndex = 0;
  var getoondGemeld = {};

  // Clarity: custom events zijn terug te vinden onder Filters > Custom events
  function clarityEvent(naam) {
    try { if (typeof window.clarity === 'function') window.clarity('event', naam); } catch (e) {}
  }

  function euro(c) { var v = c / 100; return '€' + (v % 1 === 0 ? v : v.toFixed(2).replace('.', ',')); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function opslag(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  // Gratis cadeau staat aan? Dan heeft dat voorrang en tonen we geen eigen verzendbalk/-tekst.
  function giftActief() { return !!(window.cjGift && document.querySelector('[data-cj-gift]')); }

  function isGift(i) {
    var gv = window.cjGift ? window.cjGift.variantId : null;
    return i.variant_id === gv || i.handle === cfg.giftHandle;
  }

  function status(cart) {
    var g = 0, gq = 0, korting = 0;
    cart.items.forEach(function (i) {
      if (isGift(i)) { g += i.final_line_price; gq += i.quantity; return; }
      // Hoogste kortingspercentage op een product in het mandje (zoals de Discount Mixer-app die geeft)
      if (i.original_line_price > 0 && i.final_line_price < i.original_line_price) {
        korting = Math.max(korting, 1 - i.final_line_price / i.original_line_price);
      }
    });
    var sub = cart.items_subtotal_price - g; // al ná korting
    return {
      andere: cart.item_count - gq,
      korting: Math.min(korting, 0.9),
      rest: Math.max(0, cfg.drempel - sub),
      procent: Math.max(0, Math.min(100, Math.round(sub / cfg.drempel * 100)))
    };
  }

  function netto(prijs, s) { return Math.floor(prijs * (1 - s.korting)); }

  function geldigeTips(s) {
    if (!tips) return [];
    return tips.filter(function (k) {
      var n = netto(k.price, s);
      return n >= s.rest && n <= s.rest + TIP_MARGE;
    });
  }

  function tekst(s) {
    return s.rest > 0 ? 'Nog <strong>' + euro(s.rest) + '</strong> tot gratis verzending' : '✓ Je hebt gratis verzending';
  }
  function bar(s) { return '<div class="cj-vb__bar"><span style="width:' + s.procent + '%"></span></div>'; }

  function balkHtml(s) {
    var klein = opslag(KLEIN) === '1';
    return '<div class="cj-vb__inner' + (klein ? ' is-klein' : '') + '">' +
      '<a class="cj-vb__tekst" href="' + root + 'cart" data-cj-vb-balklink>' + tekst(s) + '</a>' +
      '<button type="button" class="cj-vb__toggle" data-cj-vb-toggle aria-expanded="' + !klein + '" aria-label="' + (klein ? 'Uitklappen' : 'Inklappen') + '">' + PIJL + '</button>' +
      '</div>' + bar(s);
  }

  function prijsHtml(k, s) {
    var n = netto(k.price, s);
    if (n < k.price) return '<s class="cj-vb__oud">' + euro(k.price) + '</s> ' + euro(n);
    return euro(k.price);
  }

  function tipHtml(s) {
    if (!(s.rest > 0 && s.rest <= cfg.tipGrens)) return '';
    var lijst = geldigeTips(s);
    if (!lijst.length) return '';
    var k = lijst[tipIndex % lijst.length];
    var kop = giftActief() ? 'Nog ' + euro(s.rest) + ' tot gratis verzending. Hiermee zit je erboven:' : 'Hiermee verzend je gratis:';
    return '<div class="cj-vb__tip"><span class="cj-vb__tipkop">' + kop + '</span>' +
      '<div class="cj-vb__item">' +
        (k.img ? '<a href="' + esc(k.url) + '" data-cj-vb-tiplink><img src="' + esc(k.img) + '" alt="' + esc(k.title) + '" width="48" height="48" loading="lazy"></a>' : '') +
        '<div class="cj-vb__info"><a class="cj-vb__titel" href="' + esc(k.url) + '" data-cj-vb-tiplink>' + esc(k.title) + '</a>' +
        '<span class="cj-vb__prijs">' + prijsHtml(k, s) + '</span></div>' +
        '<button type="button" class="cj-vb__add" data-cj-vb-add="' + k.variant + '">Toevoegen</button>' +
      '</div>' +
      (lijst.length > 1 ? '<button type="button" class="cj-vb__ander" data-cj-vb-ander>Andere tip</button>' : '') +
      '</div>';
  }

  // Plekje in de "toegevoegd"-pop-up, steeds direct boven de knoppen (dus onder het cadeaublok)
  function zorgPopup() {
    var links = document.querySelector('#cart-notification .cart-notification__links');
    if (!links) return;
    var el = document.querySelector('[data-cj-vb="popup"]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'cj-vb-blok cj-vb-blok--popup';
      el.setAttribute('data-cj-vb', 'popup');
      el.hidden = true;
    }
    if (el.nextElementSibling !== links) links.parentNode.insertBefore(el, links);
  }

  function zichtbaar(el) {
    if (el.getAttribute('data-cj-vb') === 'popup') {
      var n = document.getElementById('cart-notification');
      return !!(n && n.classList.contains('active'));
    }
    return true;
  }

  function render(cart) {
    laatste = cart;
    var s = status(cart);
    var gift = giftActief();
    zorgPopup();
    document.querySelectorAll('[data-cj-vb]').forEach(function (el) {
      var plek = el.getAttribute('data-cj-vb');
      var html = '';
      var tip = '';
      if (s.andere > 0) {
        if (plek === 'balk') {
          if (!gift) html = balkHtml(s);
        } else {
          tip = tipHtml(s);
          html = (gift ? '' : '<div class="cj-vb__kop">' + tekst(s) + '</div>' + bar(s)) + tip;
        }
      }
      el.innerHTML = html;
      el.hidden = !html;
      if (plek === 'balk') el.classList.toggle('cj-vb--klein', opslag(KLEIN) === '1');
      // Eenmaal per plek per mandje-stand melden dat de tip getoond is (voor de klikratio in Clarity)
      if (tip && zichtbaar(el)) {
        var key = plek + ':' + tipKey;
        if (!getoondGemeld[key]) { getoondGemeld[key] = true; clarityEvent('verzendtip_getoond'); }
      }
    });
    laadTips(s);
  }

  function laadTips(s) {
    var nodig = s.rest > 0 && s.rest <= cfg.tipGrens && s.andere > 0 &&
      document.querySelector('[data-cj-vb="cart"], [data-cj-vb="popup"]');
    if (!nodig) { tips = null; tipKey = null; return; }
    var key = laatste.item_count + ':' + laatste.items_subtotal_price + ':' + laatste.items.map(function (i) { return i.variant_id; }).join('-');
    if (key === tipKey) return;
    tipKey = key;
    basisFetch(root + '?sections=cj-verzend-tip')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d && d['cj-verzend-tip'];
        if (!html || key !== tipKey) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('.cj-vt');
        var cartTags = ((box && box.getAttribute('data-cart-tags')) || '').split('|').filter(Boolean);
        var aff = {};
        try { aff = JSON.parse(localStorage.getItem('casa_tag_affinity') || '{}') || {}; } catch (e) {}
        var lijst = Array.prototype.map.call(doc.querySelectorAll('.cj-vt__k'), function (k, i) {
          var tags = (k.getAttribute('data-tags') || '').split('|').filter(Boolean);
          var match = tags.filter(function (t) { return cartTags.indexOf(t) > -1; }).length;
          var a = tags.reduce(function (x, t) { return x + (aff[t] || 0); }, 0);
          var score = (k.getAttribute('data-rel') === '1' ? 100 : 0) + match * 10 +
            (k.getAttribute('data-type-match') === '1' ? 5 : 0) + Math.min(a, 50);
          return {
            variant: Number(k.getAttribute('data-variant')),
            price: Number(k.getAttribute('data-price')),
            title: k.getAttribute('data-title'),
            url: k.getAttribute('data-url'),
            img: k.getAttribute('data-img'),
            score: score, i: i
          };
        });
        lijst.sort(function (a, b) { return (b.score - a.score) || (a.price - b.price) || (a.i - b.i); });
        tips = lijst;
        tipIndex = 0;
        if (laatste) render(laatste);
      })
      .catch(function () {});
  }

  function refresh() {
    basisFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function bubbelBijwerken() {
    basisFetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var el = document.getElementById('cart-icon-bubble');
        var html = d && d['cart-icon-bubble'];
        if (!el || !html) return;
        var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (sec) el.innerHTML = sec.innerHTML;
      })
      .catch(function () {});
  }

  // Bij elke mandjewijziging bijwerken (pop-up, aantallen, snel toevoegen, cadeau, apps)
  var vorigeFetch = window.fetch;
  window.fetch = function (input) {
    var p = vorigeFetch.apply(window, arguments);
    var url = String((input && input.url) || input || '');
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refresh, 400); }, function () {});
    }
    return p;
  };

  // Pop-up gaat open: tip opnieuw tekenen zodat 'getoond' ook dan geteld wordt
  document.addEventListener('transitionend', function (e) {
    if (e.target && e.target.id === 'cart-notification' && laatste) render(laatste);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var add = t.closest('[data-cj-vb-add]');
    if (add) {
      e.preventDefault();
      clarityEvent('verzendtip_toevoegen');
      add.disabled = true;
      add.textContent = '…';
      window.fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(add.getAttribute('data-cj-vb-add')), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          clarityEvent('verzendtip_toegevoegd');
          bubbelBijwerken();
          if (opCart) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cj-verzend' });
            } else {
              location.reload();
            }
          }
        })
        .catch(function () { add.disabled = false; add.textContent = 'Toevoegen'; });
      return;
    }
    if (t.closest('[data-cj-vb-tiplink]')) { clarityEvent('verzendtip_product_bekeken'); return; }
    if (t.closest('[data-cj-vb-balklink]')) { clarityEvent('verzendbalk_klik'); return; }
    if (t.closest('[data-cj-vb-ander]')) {
      e.preventDefault();
      clarityEvent('verzendtip_andere');
      tipIndex++;
      if (laatste) render(laatste);
      return;
    }
    if (t.closest('[data-cj-vb-toggle]')) {
      e.preventDefault();
      var nuKlein = opslag(KLEIN) !== '1';
      clarityEvent(nuKlein ? 'verzendbalk_ingeklapt' : 'verzendbalk_uitgeklapt');
      opslag(KLEIN, nuKlein ? '1' : null);
      if (laatste) render(laatste);
    }
  });

  function start() {
    if (cfg.cart) render(cfg.cart); else refresh();
    // nogmaals na het cadeau-script, zodat de volgorde in de pop-up klopt
    setTimeout(function () { if (laatste) render(laatste); }, 300);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
